export const packageScheduledChangeActionTypes = {
    STORE_PACKAGE_SCHEDULED_CHANGES: 'STORE_PACKAGE_SCHEDULED_CHANGES',
    CLEAR_PACKAGE_SCHEDULED_CHANGES: 'CLEAR_PACKAGE_SCHEDULED_CHANGES',
} as const;
